import { Card } from './card.model';
import { TabDto } from './tab.dto';

export class TabView extends TabDto {
  active: boolean;
  disabled: boolean;
  removable: boolean;
  customClass: string;
  isAnimationActive: string;

  constructor(name: string, cards: Card[], removable: boolean, customClass: string, active: boolean = false) {
    super(name, cards);
    this.removable = removable;
    this.customClass = customClass;
    this.active = active;
    this.isAnimationActive = 'open';
  }
}
